import type { UserStatusResponse } from '@src/api/punchTypes';
import { ClockedInView } from './ClockedInView';
import { BreakView } from './BreakView';
import { GreetingView } from './GreetingView';

interface LeftPanelProps {
    response: UserStatusResponse;
}

export function LeftPanel({ response }: LeftPanelProps) {
    switch (response.status) {
        case 'clocked_out':
            return <GreetingView user={response.user} />;
        case 'clocked_in':
            return (
                <ClockedInView
                    user={response.user}
                    punch={response.punch}
                    serverTime={response.serverTime}
                />
            );
        case 'on_break':
            return (
                <BreakView
                    user={response.user}
                    currentBreak={response.currentBreak}
                    punch={response.punch}
                    serverTime={response.serverTime}
                />
            );
    }
}
